// extracted by mini-css-extract-plugin
export default {"details":"AddPlaceModalDetails_details__qiXPY","buttons":"AddPlaceModalDetails_buttons__LQZd8"};